package com.partejar.app.feature.profile.data.remote

import com.partejar.app.feature.profile.data.UserProfile
import com.partejar.app.feature.profile.data.UserProfessionalRegistration

class UserProfileRemoteMapper {
    fun map(dto: UserProfileDto) = UserProfile(
        id = dto.id,
        name = dto.nomeCompleto ?: dto.nome,
        cpf = dto.cpf,
        email = dto.email
    )

    fun registration(dto: UserProfessionalRegistrationDto) = UserProfessionalRegistration(dto.id, dto.categoriaProfissional, dto.conselho, dto.numero, dto.uf, dto.ativo)
}
